import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import {
  useBaseAsync,
  type HpsfirProTableColumn,
  type HpsfirProTableData,
  type HpsfirProTableFilter,
  type HpsfirProTableGetDataFunction,
  type HpsfirProFormItem,
} from 'hpsfir-managebase-ui';

import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';
import dayjs from 'dayjs';
import { normalizeBizTableColumns } from '@/utils/tableColumns';


export default /*@__PURE__*/_defineComponent({
  __name: 'relate',
  emits: ["setPrimary"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;


const columns = ref<HpsfirProTableColumn[]>(normalizeBizTableColumns([]));
const tableRef = ref<any>();
const setPrimaryDialog = ref<any>();
const appid = ref('');
const visible = ref(false);
const addInitValue = {

};
const conditionsInitValue = {
};


// eslint-disable-next-line max-lines-per-function
const init = useBaseAsync(() => {
  columns.value = normalizeBizTableColumns([
    {
      name: 'nickname',
      label: '小程序名称',
      type: 'string',
    },
    {
      name: 'appid',
      label: '小程序APPID',
      type: 'string',
    },
    {
      name: 'status',
      label: '关联状态',
      type: 'select',
      options: [
        {
          label: '未关联',
          value: 0,
        },
        {
          label: '已关联',
          value: 1,
        },
        {
          label: '待小程序管理员确认',
          value: 2,
        },
        {
          label: '小程序管理员拒绝关联',
          value: 3,
        },
        {
          label: '待公众号管理员确认',
          value: 12,
        },
      ],
    },

  ]);
});


const currentRow = ref<any>();

const operates: any[] = [
  {
    key: 'relate',
    name: '建立关联',
    handler: useBaseAsync(async(row: any) => {
      await useApi().wxApi.relativeWeappwx({
        appid: appid.value,
        weappAppid: row.appid,
      });
      ElMessage.success('建立成功');
      tableRef.value?.refresh();
    }),
  },
  {
    key: 'setPrimary',
    name: '设为主小程序',
    handler: useBaseAsync((row: any) => {
      currentRow.value = row;
      setPrimaryDialog.value?.showDialog(row);
    }),
  },
];

const loading = ref(false);


const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;
    const res = await useApi().wxApi.getRelativeWeappwx({
      appid: appid.value,
    });
    const tableData: HpsfirProTableData = {
      total: res.data.data?.length || 0,
      data: res.data.data || [],
    };

    return tableData;
  } finally {
    loading.value = false;
  }
});

const handleSetPrimaryAction = useBaseAsync(() => {
  emit('setPrimary', currentRow.value.appid);
  visible.value = false;
});
const deleteFun = useBaseAsync(async(data: any) => {
  await useApi().wxApi.cancelRelativeWeappwx({
    appid: appid.value,
    weappAppid: data.appid,
  });
  ElMessage.success('解除成功');
});

const formatDeleteInfo = (row: any) => `您正在进行解除关联(${row.nickname})操作，请谨慎操作`;

const setPrimaryDangderInfo = (row: any) => `您正在进行设置主小程序(${row.nickname})操作`;

init();
__expose({
  show: (_appid: string) => {
    appid.value = _appid;
    tableRef.value?.refresh();
    visible.value = true;
  },
});


return (_ctx: any,_cache: any) => {
  const _component_HpsfirProTable = _resolveComponent("HpsfirProTable")!
  const _component_HpsfirProDangerDialog = _resolveComponent("HpsfirProDangerDialog")!
  const _component_HpsfirProDrawer = _resolveComponent("HpsfirProDrawer")!

  return (_openBlock(), _createBlock(_component_HpsfirProDrawer, {
    open: visible.value,
    "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
    title: "关联小程序",
    width: "80vw",
    "max-width": "1200px",
    "content-class": "business-table-drawer",
    "body-class": "business-table-drawer__body"
  }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createBlock(_component_HpsfirProTable, {
            key: 0,
            ref_key: "tableRef",
            ref: tableRef,
            "export-file-name": "关联小程序",
            columns: columns.value,
            "get-data": _unref(getData),
            "on-delete": _unref(deleteFun),
            "delete-text": "解除关联",
            loading: loading.value,
            "is-dangder-delete": true,
            "format-dangder-delete-info": formatDeleteInfo,
            "row-key": "id",
            operates: operates,
            "add-init-values": addInitValue,
            "codition-init-values": conditionsInitValue
          }, null, 8, ["columns", "get-data", "on-delete", "loading"]))
        : _createCommentVNode("", true),
      _createVNode(_component_HpsfirProDangerDialog, {
        ref_key: "setPrimaryDialog",
        ref: setPrimaryDialog,
        title: "警告",
        "opt-name": "设置",
        "on-ok": _unref(handleSetPrimaryAction),
        "format-dangder-delete-info": setPrimaryDangderInfo
      }, null, 8, ["on-ok"])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})